import { render, staticRenderFns } from "./RequestsMobile.vue?vue&type=template&id=ddef6300&lang=pug&"
import script from "./RequestsMobile.vue?vue&type=script&lang=js&"
export * from "./RequestsMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports